import React, { useEffect, useState } from "react";
import { Form, Skeleton, message, Row, Col } from "antd";
import { SaveButton, InputText, CancelButton, ModalComponent, trans, InputDate, SelectWithSearch } from "@comps/components"
import { makeRequest, getErrorProps } from "@utils/helpers";
import { createDataReq, getRelatedDataReq } from "../requests";
import { Commons, Const } from "../../constants";
import { createSelectList, sortSelectListByLabel } from '@comps/commonFunctions';
import { makeFieldLabel } from "@utils/fieldTooltips";
import { payrollHelpText } from "../../payrollHelpText";


const langKey = Const["saleIncentives"].lngKey


const fieldLabel = makeFieldLabel(payrollHelpText.saleIncentive, { namespace: "saleIncentive", label: (key) => trans(`${langKey}.${key}`) });
const formName = "createAttendanceRequest";
const CreateSaleIncentives = (props) => {
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [isFlat, setIsFlat] = useState(false);
  const [errors, setErrors] = useState([]);
  const [branches, setBranches] = useState([]);
  const [designations, setDesignations] = useState([]);

  const [incentiveTypes, setIncentiveTypes] = useState([])

  const [form] = Form.useForm()
  useEffect(() => {
    getRelatedData()
    // eslint-disable-next-line
  }, []);

  const getRelatedData = () => {
    makeRequest(setLoader, getRelatedDataReq, null, setRelatedData, null);
  }
  const setRelatedData = (res, data) => {
    setBranches(createSelectList(res.branches))
    setDesignations(createSelectList(res.designations))
    setIncentiveTypes(sortSelectListByLabel(createSelectList(res.payitems)))
  }

  const onSubmit = (data) => {
    data.month = data.month.date(1);
    const payload = {
      incentive: {
        company_id: localStorage.getItem('company_id') ? localStorage.getItem('company_id') : 1,
        branch_id: data.branch_id,
        designation_id: data.designation_id,
        payitem_id: data.payitem_id,
        month: data.month.format('YYYY-MM-DD'),
        total_amount: data.total_amount,
        is_flat: data.is_flat,
        applicable_amount: data.applicable_amount
      }
    }
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
    setSaveLoader(true)
  }
  const onSuccess = (data, res) => {
    setSaveLoader(false)
    message.success("Saved successfully");
    props.onCompleted(data.incentives.data);
    props.onSuccess(data)
  }

  const onError = (err, res) => {

    setSaveLoader(false)
    message.error(res.response.data.message);
  }
  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  const footer = [
    <SaveButton loading={ saveLoader } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];
  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------
  return (
    <ModalComponent top={ 20 } width={ 1000 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Skeleton loading={ loading }>
        <Form { ...formLayout } form={ form } name={ formName } onFinish={ onSubmit }>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="branch_id" rules={ rules.branch_id } label={ fieldLabel("branch_id", trans(`${langKey}.branch_id`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['name']) } size="small"
              >
                <SelectWithSearch
                  options={ branches }
                  placeholder={ trans(`${langKey}.branch_id`) }
                />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="designation_id" rules={ rules.designation_id } label={ fieldLabel("designation_id", trans(`${langKey}.designation_id`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['name']) } size="small"
              >
                <SelectWithSearch
                  options={ designations }
                  placeholder={ trans(`${langKey}.designation_id`) }
                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="month" rules={ rules.month } label={ fieldLabel("month", trans(`${langKey}.month`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['month']) } size="small"
              >
                <InputDate picker="month" format='YYYY-MM' />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="payitem_id" rules={ rules.payitem_id } label={ fieldLabel("payitem_id", trans(`${langKey}.payitem_id`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['name']) } size="small"
              >
                <SelectWithSearch
                  options={ incentiveTypes }
                  placeholder={ trans(`${langKey}.payitem_id`) }
                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_flat" rules={ rules.is_flat } label={ fieldLabel("is_flat", trans(`${langKey}.is_flat`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['is_flat']) } size="small"
              >
                <SelectWithSearch
                  options={ [
                    {
                      label: "Percentage",
                      value: false
                    },
                    {
                      label: "Flat",
                      value: true
                    }
                  ] }
                  placeholder={ trans(`${langKey}.is_flat`) }
                  onChange={ (e) => setIsFlat(e) }
                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="total_amount" rules={ rules.total_amount } label={ fieldLabel("total_amount", trans(`${langKey}.total_amount`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['total_amount']) } size="small"
                initialValue={ 0 }
              >
                <InputText placeholder={ trans(`${langKey}.total_amount`) } type="number" onWheel={ (e) => e.target.blur() } />
              </Form.Item>
            </Col>


            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="applicable_amount" rules={ rules.applicable_amount } label={ fieldLabel("applicable_amount", trans(`${langKey}.applicable_amount`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['applicable_amount']) } size="small"
              >
                <InputText placeholder={ trans(`${langKey}.applicable_amount`) } type="number" onWheel={ (e) => e.target.blur() } />
              </Form.Item>
            </Col>
          </Row>

        </Form>
      </Skeleton>
    </ModalComponent>
  )
}

export default CreateSaleIncentives

const rules = {
  branch_id: [
    { required: true, message: trans(`${langKey}.branch_id.req`) },
  ],
  payitem_id: [
    { required: true, message: trans(`${langKey}.payitem_id.req`) },
  ],
  month: [
    { required: true, message: trans(`${langKey}.month.req`) },
  ],
  applicable_amount: [
    { required: true, message: trans(`${langKey}.applicable_amount.req`) },
  ],
  total_amount: [
    { required: true, message: trans(`${langKey}.total_amount.req`) },
  ],
  is_flat: [
    { required: true, message: trans(`${langKey}.is_flat.req`) },
  ],
};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}

